// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Checkbox from '../../editor/plugins/checklist/components/Checkbox';

// Style
import './CheckboxInput.scss';

const CheckboxInput = React.forwardRef(function CheckboxInput(props, formInputRef) {
    const { name, className, error, label, ...inputProps } = props;

    return (
        <div className={classNames('CheckboxInput', className, { error: !!error })}>
            <Checkbox
                checked={inputProps.checked}
                onClick={() => inputProps.onChange(!inputProps.checked)}
                error={!!error}
            />
            <input
                className="CheckboxHiddenInput"
                id={name}
                name={name}
                ref={formInputRef}
                type="checkbox"
                {...inputProps}
            />
            {label}
        </div>
    );
});

CheckboxInput.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    error: PropTypes.object,
    label: PropTypes.node,
};

export default CheckboxInput;
